import { useEffect, useRef } from "react";
import { config } from "../config";

export const useStalledCheck = (
  getCurrentTime: () => Promise<number>,
  loadNextItem: () => void,
) => {
  const currentTimeRef = useRef<{ time: number; at: number } | null>(null);

  useEffect(() => {
    const interval = setInterval(async () => {
      const currentTime = await getCurrentTime();
      const now = new Date().getTime();

      currentTimeRef.current = {
        time: currentTime,
        at:
          currentTimeRef.current == null ||
          currentTimeRef.current.time !== currentTime
            ? now
            : currentTimeRef.current.at,
      };

      if (now - currentTimeRef.current.at >= config.mediaStalledTimeout) {
        loadNextItem();
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [getCurrentTime, loadNextItem]);
};
